window.addEventListener("DOMContentLoaded", () => {
	sizingGuideWrapper();

	function sizingGuideWrapper() {
		let sizes = {
			triangl: ["XXS", "XS", "S", "M", "L", "XL"],
			regions: {
				US: ["0", "2", "4", "6", "8", "10"],
				EU: ["32", "34", "36", "38", "40", "42"],
				IT: ["36", "38", "40", "42", "44", "46"],
				FR: ["32", "34", "36", "38", "40", "42"],
				UK: ["4", "6", "8", "10", "12", "14"],
				AUS: ["4", "6", "8", "10", "12", "14"]
			},
			tops: [
				["76-79", "67-70"],
				["80-83", "71-74"],
				["84-87", "75-78"],
				["88-91", "79-82"],
				["92-95", "83-86"],
				["96-99", "87-90"]
			],
			bottoms: [
				["59-62", "85-88", "75-78"],
				["63-66", "89-92", "79-82"],
				["67-70", "93-96", "83-86"],
				["71-74", "97-100", "87-90"],
				["75-78", "101-104", "91-94"],
				["79-82", "105-108", "95-98"]
			]
		};
		topsAndBottomsGuide();

		function topsAndBottomsGuide() {
			document.addEventListener("click", function(selectionClick) {
				const sizingTypeOption = document.getElementsByClassName("sizing-type-option");

				for (let k = 0; k < sizingTypeOption.length; k++) {
					const sizingOption = sizingTypeOption[k];
					const availableTypesAttr = sizingOption.getAttribute("sizing-type-current-selection");

					const targetHasSelection = selectionClick.target.hasAttribute("sizing-type-current-selection");
					const targetParentHasSelection = selectionClick.target.parentNode.parentNode.hasAttribute("sizing-type-current-selection");

					if (targetHasSelection || targetParentHasSelection) {
						const clickedSelection = targetHasSelection ? selectionClick.target : selectionClick.target.parentNode.parentNode;
						const clickedSelectionValue = clickedSelection.getAttribute("sizing-type-current-selection");

						if (clickedSelectionValue === availableTypesAttr) {
							sizingOption.classList.add("checked");
							sizingOption.parentNode.classList.add("checked");
						} else {
							sizingOption.classList.remove("checked");
							sizingOption.parentNode.classList.remove("checked");
						}
					}
				}
			}), document.addEventListener("click", function(eventClicked) {
				const sizingGuideData = document.getElementsByClassName("sizing-guide__data");
				if (eventClicked.target.getAttribute("data-style-option") == "tops" || eventClicked.target.parentNode.parentNode.getAttribute("data-style-option") == "tops")
					for (let i = 0; i < sizingGuideData.length; i++) sizingGuideData[i].hasAttribute("data-size-result-top") && sizingGuideData[i].classList.remove("hide"), sizingGuideData[i].hasAttribute("data-size-result-bottom") && sizingGuideData[i].classList.add("hide");
				if (eventClicked.target.getAttribute("data-style-option") == "bottoms" || eventClicked.target.parentNode.parentNode.getAttribute("data-style-option") == "bottoms")
					for (let i = 0; i < sizingGuideData.length; i++) sizingGuideData[i].hasAttribute("data-size-result-top") && sizingGuideData[i].classList.add("hide"), sizingGuideData[i].hasAttribute("data-size-result-bottom") && sizingGuideData[i].classList.remove("hide")
			});
			let divSizingRegionSelectors = document.getElementsByClassName("options-selector__label-region-option"),
				divSizeInputs = document.getElementsByClassName("options-selector__label-size-numbers");
			for (let i = 0; i < divSizingRegionSelectors.length; i++) divSizingRegionSelectors[i].addEventListener("click", function() {
				if (divSizingRegionSelectors[i].innerText == "US")
					for (let k = 0; k < sizes.regions.US.length; k++) divSizeInputs[k].innerHTML = sizes.regions.US[k];
				if (divSizingRegionSelectors[i].innerText == "EU")
					for (let k = 0; k < sizes.regions.EU.length; k++) divSizeInputs[k].innerHTML = sizes.regions.EU[k];
				if (divSizingRegionSelectors[i].innerText == "IT")
					for (let k = 0; k < sizes.regions.IT.length; k++) divSizeInputs[k].innerHTML = sizes.regions.IT[k];
				if (divSizingRegionSelectors[i].innerText == "FR")
					for (let k = 0; k < sizes.regions.FR.length; k++) divSizeInputs[k].innerHTML = sizes.regions.FR[k];
				if (divSizingRegionSelectors[i].innerText == "UK")
					for (let k = 0; k < sizes.regions.UK.length; k++) divSizeInputs[k].innerHTML = sizes.regions.UK[k];
				if (divSizingRegionSelectors[i].innerText == "AUS")
					for (let k = 0; k < sizes.regions.AUS.length; k++) divSizeInputs[k].innerHTML = sizes.regions.AUS[k]
			});
			document.addEventListener("click", function(sizeClick) {
				const sizingLabelTriangl = document.getElementsByClassName("sizing-label-triangl");
				for (let loopLabels = 0; loopLabels < sizingLabelTriangl.length; loopLabels++) sizeClick.target.getAttribute("for") == "sizing-size-0" && (sizingLabelTriangl[loopLabels].classList.add("hide"), sizingLabelTriangl[loopLabels].getAttribute("data-size-result") == "XXS" && sizingLabelTriangl[loopLabels].classList.remove("hide")), sizeClick.target.getAttribute("for") == "sizing-size-1" && (sizingLabelTriangl[loopLabels].classList.add("hide"), sizingLabelTriangl[loopLabels].getAttribute("data-size-result") == "XS" && sizingLabelTriangl[loopLabels].classList.remove("hide")), sizeClick.target.getAttribute("for") == "sizing-size-2" && (sizingLabelTriangl[loopLabels].classList.add("hide"), sizingLabelTriangl[loopLabels].getAttribute("data-size-result") == "S" && sizingLabelTriangl[loopLabels].classList.remove("hide")), sizeClick.target.getAttribute("for") == "sizing-size-3" && (sizingLabelTriangl[loopLabels].classList.add("hide"), sizingLabelTriangl[loopLabels].getAttribute("data-size-result") == "M" && sizingLabelTriangl[loopLabels].classList.remove("hide")), sizeClick.target.getAttribute("for") == "sizing-size-4" && (sizingLabelTriangl[loopLabels].classList.add("hide"), sizingLabelTriangl[loopLabels].getAttribute("data-size-result") == "L" && sizingLabelTriangl[loopLabels].classList.remove("hide")), sizeClick.target.getAttribute("for") == "sizing-size-5" && (sizingLabelTriangl[loopLabels].classList.add("hide"), sizingLabelTriangl[loopLabels].getAttribute("data-size-result") == "XL" && sizingLabelTriangl[loopLabels].classList.remove("hide"))
			})
		}
	}
});